import { render, staticRenderFns } from "./PriceReferenceForm.vue?vue&type=template&id=b9909906&scoped=true"
import script from "./PriceReferenceForm.vue?vue&type=script&lang=js"
export * from "./PriceReferenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9909906",
  null
  
)

export default component.exports